import { useEffect, useState } from 'react'
import DynamicDownloadBtnSection from '../../../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection'
import "./Outcomes.scss";
import { useContext } from 'react';
import { AppContext } from '../../../../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';

const Outcomes = () => {

    const { backendUrl } = useContext(AppContext);
    const [allOutcomesReports, setAllOutcomesReports] = useState([]);
     let errorShown = false;

       async function fetchAllOutcomesReports() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllOutcomes`);
            if (data.success) {
                setAllOutcomesReports(data || []);
            } 
            errorShown = false;  
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
            if (error.response && error.response.status === 503) {
                            toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                        }
                        else if (!navigator.onLine) {
                            toast.error("🚫 No internet connection. Please check your network.");
                        }
            
                        else if (error.request && !error.response) {
                            toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                        }
                        else 
                        {
                            console.error("Unexpected error:", error);
                            toast.error("Something went wrong.");
                        }
        }
    }

    useEffect(() => {
        fetchAllOutcomesReports();
    }, [])

    const content = allOutcomesReports?.reports
        ?.filter(item => item.isActive)
        .map(item => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];

    return (
        <section className="outcomesMainContainer">
            <header className="outcomesHeader">
                <h2>Outcomes</h2>
            </header>
            <DynamicDownloadBtnSection
                items={content}
                yearFontSize={1.25}
            />
        </section>
    )
}

export default Outcomes 
